export const VUEX_ROUTING_ENTER_DASHBOARD = 'VUEX_ROUTING_ENTER_DASHBOARD'
